import report from '../../../utils/codecResultReporter';

import pick from 'lodash/pick';
import { NewQuoteCodec } from 'foundshared/src/api/quotes/codecs';
import { isLeft } from 'fp-ts/lib/Either';

import type { NewQuote } from 'foundshared/src/api/quotes/types';
import type { QuoteBuilderValues } from './formState';

export function generateNewQuote(context?: QuoteBuilderValues, catalogueId?: string | null): NewQuote | undefined {
  if (!context) return undefined;

  const data = {
    catalogueId,
    location: { adminArea: context.location?.state, ...pick(context.location, ['locality', 'postcode']) },
    productTypeId: Number(context.productTypeId),
    additives: context.additives ? Number(context.additives) : undefined,
    agg: context.agg ? Number(context.agg) : undefined,
    colour: context.colour ? Number(context.colour) : undefined,
    mpa: context.mpa ? Number(context.mpa) : undefined,
    quantity: context.quantity.toString(),
    slump: context.slump ? Number(context.slump) : undefined,
  };

  const result = NewQuoteCodec.decode(data);

  if (isLeft(result)) {
    throw new Error(`Quote details aren't filled in correctly ${JSON.stringify(report(result), null, 2)}`);
  } else {
    return result.right;
  }
}
